<template>
    <div class="header">
        <div class="headerTitle" />

        <div class="days">
            <div v-for="i in daysInMonth">
                <strong :class="{isToday: isToday(i)}">
                    {{day(i)}}
                </strong>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    $headerTitleWidth: 200px;
    $padding: 10px;

    .header {
        position: sticky;
        top: 0;
        background-color: #fff;

        display: flex;
        font-size: 15px;
        border-top: 3px solid #e0e0e0;

        &:last-child {
            border-bottom: 3px solid #e0e0e0;
        }

        .headerTitle {
            font-size: 10pt;
            min-width: $headerTitleWidth;
            padding: $padding;
            font-weight: 500;
            margin-top: 3px;
        }

        .days {
            display: flex;
            flex: 1 0 auto;

            > * {
                color: #ccc;

                padding: $padding;

                flex-grow: 1;
                flex-shrink: 1;
                flex-basis: 0;
                text-align: center;
            }

            .isToday {
                color: #4b00ff !important;
            }
        }
    }
</style>

<script>
    const moment = require('moment')

    export default {
        props: {
            date: Object
        },

        computed: {
            daysInMonth() {
                if (!this.date) {
                    return 0
                }

                return this.date.daysInMonth()
            }
        },

        methods: {
            day(num) {
                const date = moment(this.date)
                date.date(num)

                return date.format('dd')
            },

            isToday(num) {
                const format = 'YYYY-MM-DD'

                const today = moment()
                const date = moment(this.date)
                date.date(num)

                return today.format(format) === date.format(format)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// HeaderBlock.vue?e16a7d62